import { useEffect, useState } from "react";
import { Tabs, TabsProps } from "antd";
import clsx from "clsx";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { ManageIcon, ProjectIcon } from "@shared/assets/svg/icons";
import { useNavigate, routes } from "@shared/lib/react-router";
import { ExtendableComponent } from "@shared/types/components.ts";
import "./tabs-menu.scss";

interface TabsMenuProps extends ExtendableComponent {}

export const TabsMenu = ({ className }: TabsMenuProps) => {
  const [tab, setTab] = useState(routes.projects());
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setTab(`/${location.pathname.split("/")?.[1]}/`);
  }, [location.pathname]);

  useEffect(() => {
    const checkAdmin = () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded: any = jwtDecode(token);
          setIsAdmin(
            decoded?.roleId === "ADMIN" || decoded?.roleName === "account:admin",
          );
        } catch (e) {
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    };
    checkAdmin();
    const interval = setInterval(checkAdmin, 1000); // check every second
    return () => clearInterval(interval);
  }, []);

  const tabs: TabsProps["items"] = [
    {
      key: routes.projects(),
      label: (
        <span className="tabs-menu-label">
          <ProjectIcon className="tabs-menu-label__icon" width={24} height={24} />
          <div className="tabs-menu-label__text">Проекты</div>
        </span>
      ),
    },
    ...(isAdmin
      ? [
          {
            key: routes.organization(),
            label: (
              <span className="tabs-menu-label">
                <ManageIcon className="tabs-menu-label__icon" width={24} height={24} />
                <div className="tabs-menu-label__text">Управление</div>
              </span>
            ),
          },
        ]
      : []),
  ];

  const onTabChange = (key: string) => {
    navigate(key);
  };

  return (
    <Tabs
      activeKey={tab}
      onTabClick={onTabChange}
      className={clsx("tabs-menu", className)}
      defaultActiveKey="1"
      items={tabs}
    />
  );
};
